import { environment } from '../../../environments/environment';

export class EndPoint {
  static url(resource: string) {
    return environment.url + resource;
  }

  static urlBase(resource: string) {
    return environment.base_url + resource;
  }

  static urlBasePrediction(resource: string) {
    return environment.prediction_url + resource;
  }

  static urlBaseAdmin(resource: string) {
    return environment.admin_url + resource;
  }

  static urlBaseConsumption(resource: string) {
    return environment.consumption_url + resource;
  }

  static isProduction(): boolean {
    return environment.production;
  }
}
